module.exports = __webpack_public_path__ + "media/images/press_kit/test/email/top-light-small-a9f58dc1847fbeb63d09980a2113b008.png";